import { SpaceIndex } from "../../../../core/space-index";
import { SQLTables } from "../table/tables";
import { SQLExtensionGenerator } from "./base";

export class PostgreSQL extends SQLExtensionGenerator {
  constructor(private readonly index: SpaceIndex) {
    super();
  }

  values(tables: SQLTables): string {
    let code = ``;

    for (const table of tables.tables) {
      const columns = table
        .columns()
        .filter((c) => !c.disabled())
        .map((c) => c.name().postgres)
        .join(", ");

      code += `INSERT INTO ${table.name().postgres} (${columns})\n`;

      code += `VALUES\n`;

      const values = [] as string[];

      table.iterate((row) => {
        this.index.push();

        const v = row.map((v) => v.string().postgres).join(", ");
        const rowCode = this.index.create(`(${v})`);
        values.push(rowCode);

        this.index.reverse();
      });

      code += `${values.join(",\n")};\n\n`;
    }

    return code;
  }

  tables(tables: SQLTables): string {
    let code = ``;

    for (const table of tables.tables) {
      code += `CREATE TABLE ${table.name().postgres} (\n`;

      const columns = table
        .columns()
        .filter((c) => !c.disabled())
        .map((column) => {
          let code = ``;

          this.index.push();

          code += this.index.create(
            `${column.name().postgres} ${column.definition().postgres}`,
          );

          if (column.isKey()) {
            code += ` PRIMARY KEY`;
          } else {
            if (column.isUnique()) {
              code += ` UNIQUE`;
            }

            if (!column.isNull()) {
              code += ` NOT NULL`;
            }
          }

          const ref = column.ref();
          if (ref !== null) {
            const table = ref.table.name().postgres;
            const col = ref.column.name().postgres;

            code += ` REFERENCES ${table}(${col})`;
          }

          this.index.reverse();

          return code;
        })
        .join(",\n");

      code += `${columns}` + "\n";

      code += `);\n\n`;
    }

    return code;
  }
}
